var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"blue-bg"},[_c('section',[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t("Forbidden")))]),_vm._v(" "),_c('p',[_vm._v("\n        "+_vm._s(_vm.$t("You don't have permission to access this page."))+"\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }